import glamorous from 'glamorous';

const MenuGroup = glamorous('div')({
    display: 'flex',
    flexDirection: 'column',
});

export default MenuGroup;
